<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body" style="background-color: rgb(49 105 146);">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo />
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid" style="max-width: 45%;"
                                                                                               :src="`${publicPath}app-assets/images/pages/verify2.png`"
                                                                                               alt="Login V2"/></div>
              <div style="position: absolute;top: 70%;">
                <h3 class="text-white cursiveFont">Payment Processing </h3>
                <h3 class="text-white cursiveFont"> Made Easy!</h3>
                <p class="text-white mb-0 ">Online credit/ debit card payments.</p>
                <p class="text-white mb-0 ">Recurring/ Subscription payments.</p>
                <p class="text-white mb-0 ">End to end payment management.</p>
                <p class="text-white mb-0 ">QR code payments.</p>
              </div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75" :src="`${publicPath}images/vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Please Verify You Email! 👋</h3>
                <p class="card-text mb-2">The otp will be sent to the following email address</p>
                <Form class="auth-login-form mt-2" @submit="sendCall" :validation-schema="schema" :initial-values="{email: email}">
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <Field name="email" class="form-control" type="email" disabled placeholder="Email" v-model="email" />
                    <ErrorMessage name="email" />
                  </div>
                  <div class="mt-2">
                    <Button class="btn btn-primary btn-block" :loading="loader">Confirm</Button>
                  </div>
                </form>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reCaptchaMixin from '@/mixins/reCaptchaMixin';
export default {
  mixins: [reCaptchaMixin],
  mounted() {
    if (typeof (this.$route.params.email) == 'undefined') {
      let email = localStorage.getItem('email');
      if (email != '' && email !== null) {
        this.email = email
      } else {
        this.$router.push({name: 'send-otp'});
      }
    } else {
      this.email = this.$route.params.email
    }
  },
  data(){
    return{
      loader: false,
      email: '',

    }
  },
  methods: {
    goToLogin(){
      this.$router.push({name: 'login'});
    },
    async sendCall(){

      let data ={
        "email": this.email,
        "type": this.$store.getters.getResetType,
      }

      if(process.env.VUE_APP_ACTIVATE_RECAPTCHA == 'true'){
        try {
          const token = await this.executeRecaptcha('submit');
          this.recaptchaToken = token;

        } catch (error) {
          console.error('reCAPTCHA error:', error);
        }

        data = {
          ...data,
          verResponse: this.recaptchaToken,
          resId: Date.now()
        }
      }

      this.loader = true
      this.makeRequest('post','v1/verify-email-general',data).then(callResponse => {

        this.loader = false
        if(!callResponse.error){
          let code = callResponse.response.data.code;

          if(code == 200){
            if(this.$store.getters.getResetType == 1){
              this.$router.push({name:'reset-password'})
            }else if(this.$store.getters.getResetType == 2){
              this.$router.push({name:'verify-otp'})
              // this.$router.push({name:'reset-pin'})
            }
          }
        }

      });

    },
  },
}
</script>

